import { useState } from "react";
import { ReportView } from "./ReportView";
import { SegmentedFilter } from "@/components/ui/Toolbar";
import type { ReportName } from "@/lib/api/reports";

/**
 * Sifat va foydalanish hisobotlari (TZ 3.0 RPT-03).
 *
 * Bitta sahifada oltita kesim: karta sifati (VGH, foto, ИКПУ, ТН ВЭД),
 * bojxona qoldig'i, OX ga biriktirilmagan SKU, ABC zonasi mosligi,
 * noto'g'ri manzildagi LP va 30/60/90 kun harakatsiz qoldiq. Katak
 * sig'imi «Topologiya» sahifasida. Har biri XLSX ga eksport qilinadi.
 */
const REPORTS: Array<{ value: ReportName; label: string; title: string; hint: string }> = [
  {
    value: "data-quality",
    label: "Karta",
    title: "Karta sifati",
    hint: "VGH, vazn, foto, shtrix-kod, ИКПУ va ТН ВЭД yetishmayotgan SKU kartalari.",
  },
  {
    value: "customs-stock",
    label: "Bojxona",
    title: "Bojxona qoldig'i",
    hint: "CUSTOMS_HOLD sifatidagi qoldiq — ruxsat kutilmoqda; eng uzoq turgani tepada.",
  },
  {
    value: "sku-without-ox",
    label: "OX siz",
    title: "OX ga biriktirilmagan SKU",
    hint: "Erkin qoldig'i bor, lekin faol OX siyosati (min/max) yo'q — korobka terish yuzi va to'ldirish yo'q.",
  },
  {
    value: "abc-zone-mismatch",
    label: "ABC zona",
    title: "ABC zonasi mosligi",
    hint: "A korpusda SKU klassi katak zonasidan farq qiladi: CLOSER — yaqinroq zonaga, FARTHER — uzoqroqqa.",
  },
  {
    value: "lp-misplaced",
    label: "LP",
    title: "Noto'g'ri manzildagi LP",
    hint: "Bir necha katakda (SPLIT), oraliq hududda 24 soatdan ortiq qotgan yoki sifati hududga zid LP.",
  },
  {
    value: "slow-moving",
    label: "Harakatsiz",
    title: "Harakatsiz qoldiq",
    hint: "Belgilangan kundan beri harakat bo'lmagan qoldiq; oraliq 30+/60+/90+.",
  },
];

export function QualityReports() {
  const [report, setReport] = useState<ReportName>("data-quality");
  const [idleDays, setIdleDays] = useState<"30" | "60" | "90">("30");
  const spec = REPORTS.find((item) => item.value === report) ?? REPORTS[0]!;

  return (
    <ReportView
      key={report}
      report={report}
      title={spec.title}
      hint={spec.hint}
      supportsIssuesFilter={report === "data-quality"}
      filters={report === "slow-moving" ? { idle_days: Number(idleDays) } : undefined}
      above={
        <div className="toolbar" aria-label="Hisobot turi">
          <SegmentedFilter
            value={report}
            onChange={setReport}
            options={REPORTS.map((item) => ({ value: item.value, label: item.label }))}
          />
          {report === "slow-moving" && (
            <SegmentedFilter
              value={idleDays}
              onChange={setIdleDays}
              options={[
                { value: "30", label: "30+ kun" },
                { value: "60", label: "60+ kun" },
                { value: "90", label: "90+ kun" },
              ]}
            />
          )}
        </div>
      }
    />
  );
}
